/**
 * Coach-facing UI toggles for sections that stay in the codebase but are not
 * surfaced in navigation until product value is there.
 *
 * When a Programs / Nutrition KPI dashboard is off:
 * - `navigationConfig` marks matching nav sub-items `hidden`
 * - `routeSlugs` remaps legacy `/programs/dashboard` and `/nutrition/dashboard` URLs
 * - In-page tab triggers are wrapped with the same flags (see ProgramDashboard,
 *   NutritionDashboard, ProgramLibraryView)
 *
 * Set the relevant flag to `true` to restore dashboards everywhere.
 */
export const SHOW_COACH_PROGRAMS_KPI_DASHBOARD = false;
export const SHOW_COACH_NUTRITION_KPI_DASHBOARD = false;

/** Sub-tab ids rewritten to the first useful screen when dashboards are hidden. */
export const HIDDEN_COACH_DASHBOARD_SUBTAB_REDIRECT: Record<string, string> = {
  'programs-dashboard': 'programs-all',
  'nutrition-dashboard': 'nutrition-meal-plans',
};
